// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"497":"7536343e6af30b75","787":"6a53245dcd725262"}[chunkId] + ".js";
};